import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { loadServiceDetailsForContractId } from '../../../store/directusService';
import { loadTeamsForService } from '../../../store/userService';
import DateSelect from '../../formElements/DateSelect';
import MultiSelect from '../../formElements/MultiSelect';
import SingleSelect from '../../formElements/SingleSelect';

import form from '../../../commonStyles/formStyles.module.css';

const ModalContentFinancialRequest = ({ contracts = [], errors, selects, onChange }) => {
    // HOOKS
    const dispatch = useDispatch();

    // STORE STATE
    const serviceDetailsForContractId = useSelector(
        (state) => state.entities.directusService.serviceDetailsForContractId
    );
    const teamsForService = useSelector((state) => state.entities.userService.teamsForService);

    // USE EFFECTS
    useEffect(() => {
        onChange('serviceId', '');
    }, [serviceDetailsForContractId]);

    useEffect(() => {
        onChange('teamIds', []);
    }, [teamsForService]);

    useEffect(() => {
        selects.contract?.id && dispatch(loadServiceDetailsForContractId(selects.contract.id));
    }, [selects.contract]);

    useEffect(() => {
        selects.serviceId && dispatch(loadTeamsForService({ serviceIds: [selects.serviceId] }));
    }, [selects.serviceId]);

    // RENDER
    return (
        <div className={form.formSection}>
            <div className={form.formColumn}>
                <SingleSelect
                    id="contract"
                    label="Contract"
                    placeholder="Select contract..."
                    mandatory={true}
                    customClass="absoluteAndHeightControl"
                    menuItems={contracts}
                    selectedId={selects.contract?.id || ''}
                    selected={
                        (selects.contract?.id &&
                            contracts.find((el) => el.id === selects.contract.id)) ||
                        {}
                    }
                    error={errors.contract}
                    onChange={(id) =>
                        onChange(
                            'contract',
                            contracts.find((el) => el.id === id)
                        )
                    }
                />
                <DateSelect
                    id="date"
                    label={'Date Selector'}
                    value={selects.date}
                    isDefault={true}
                    mandatory={true}
                    max={new Date().toISOString().split('T')[0]}
                    error={errors.date}
                    onDateChange={(date) => onChange('date', date)}
                />
            </div>
            <div className={form.formColumn}>
                <SingleSelect
                    id={'serviceId'}
                    label={'Service'}
                    placeholder="Select service..."
                    mandatory={true}
                    disabled={
                        serviceDetailsForContractId.length === 0 ||
                        !selects.contract ||
                        !selects.contract.id
                    }
                    customClass="absoluteAndHeightControlSecondLevel"
                    menuItems={serviceDetailsForContractId || []}
                    selectedId={selects.serviceId || ''}
                    selected={
                        serviceDetailsForContractId.find((el) => el.id === selects.serviceId) || {}
                    }
                    error={errors.serviceId}
                    onChange={(id) => onChange('serviceId', id)}
                />
                <MultiSelect
                    id="teamIds"
                    label="Teams"
                    placeholder="Select teams..."
                    mandatory={true}
                    disabled={!selects.serviceId}
                    customClass="absoluteAndHeightControl"
                    menuItems={teamsForService || []}
                    preSelectedIds={selects.teamIds || []}
                    preSelects={
                        teamsForService.filter((el) => selects.teamIds?.includes(el.id)) || []
                    }
                    error={errors.teamIds}
                    onChange={(ids) => onChange('teamIds', ids)}
                />
            </div>
        </div>
    );
};

ModalContentFinancialRequest.propTypes = {
    contracts: PropTypes.arrayOf(PropTypes.object),
    errors: PropTypes.object,
    selects: PropTypes.object,
    onChange: PropTypes.func
};

export default ModalContentFinancialRequest;
